import { ValidateAddressModal } from "./ValidateAddressModal";

export default ValidateAddressModal;